import { login, logout } from '@polleverywhere/slideware-bindings'
import ErrorModel from '../../models/error'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

function showGetLatestSlidewareError (options = {}) {
  console.error(options.error)
  options.state.appStates.slideware.set({
    page: 'latest-slideware',
    pageAction: null,
    error: new ErrorModel({ code: options.title, message: options.description })
  })

  store.dispatch(appSlice.pageUpdated('slideware'))
}

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenTo(state, 'session:logout', () => {
      logout()
        .catch(error => {
          showGetLatestSlidewareError({
            state,
            error,
            title: 'Logout error',
            description: 'Something blocked Poll Everywhere from logging out. Please try updating to the latest Poll Everywhere version.'
          })
        })
    })

    dispatcher.listenTo(state, 'session:start', (user) => {
      // There can be a timing issue during logout route where we the session
      // starts (because the page opened), we destroy the the session (from logout), but then we are here.
      if (!user || !user.isLoggedIn()) {
        return
      }

      login(user)
        .catch(error => {
          showGetLatestSlidewareError({
            state,
            error,
            title: 'Login error',
            description: 'Something blocked Poll Everywhere from logging in. Please try updating to the latest Poll Everywhere version.'
          })
        })
    })
  })
}
